import useAppSelector from '../../../../store/hooks/useAppSelector'
import { checkoutCapacityConflictAllocationSelector } from '../../store/checkoutSelectors'

import CapacityConflictItemGroupHeader from './CapacityConflictItemGroupHeader'
import CapacityConflictSummaryRow from './CapacityConflictSummaryRow'
import styles from './CapacityConflictItemsList.module.scss'

/**
 * Everything the kitchen is short on, in one scrolling list: what's being
 * trimmed to fit, then what can't be made at all.
 */
export default function CapacityConflictItemsList() {
  const allocation = useAppSelector(checkoutCapacityConflictAllocationSelector)

  if (!allocation) {
    return null
  }

  return (
    <div className={styles.itemsList}>
      {allocation.groups.map(group => (
        <div key={group.kind} className={styles.group}>
          <CapacityConflictItemGroupHeader
            kind={group.kind}
            count={group.rows.length}
          />
          {group.rows.map(row => (
            <CapacityConflictSummaryRow key={row.lineId} row={row} />
          ))}
        </div>
      ))}
    </div>
  )
}
